<template>
    <section>
        <b-overlay :show="loading" rounded="sm">
            <select v-model="showing" v-if="false">
                <option value="9">Top 10</option>
                <option value="4">Top 5</option>
                <option value="2">Top 3</option>
                <option value="all" selected>Show All</option>
            </select>
            <b-row class="text-center">
                <b-col>
                    % Profit por:
                    <select v-model="by" @change="fetchDataChart">
                        <option value="zone">Zonas Maestras</option>
                        <option value="vehicle">Categoria Vehiculo</option>
                        <option value="supplier">Proveedor</option>
                        <option value="sale-channel">Canal de venta</option>
                    </select>
                    <b-button variant="outline-primary"  @click="fetchDataChart" size="sm" class="ml-2" :disabled="loading" >
                        <md-icon icon="search"/>
                    </b-button>
                </b-col>
            </b-row>
            <chart :options="chartOptions"  ref="chart"></chart>
            <select v-model="selectedCategory" @change="filterByCategory">
                <option value="" selected>Show All Categories</option>
                <option v-for="category in originalCategories" :key="category" :value="category">{{ category }}</option>
            </select><br>
            <span>Total de rides:{{totalRides}}</span>
        </b-overlay>

    </section>
</template>

<script>
    import {Chart} from 'highcharts-vue'
    import api from '../../../../../api.js'
    import Highcharts from 'highcharts'
    import exportingInit from 'highcharts/modules/exporting'
    exportingInit(Highcharts)

    export default {
        name: "AverageProfitPerVehicle",
        components:{Chart},
        props: {
            filters: {
                type : Object,
                required: true
            },
            triggerSearch:{
                type : Number,
                required: true
            }
        },
        data(){
            let seriesExample = [{
                name:"",
                data:[]
            }];
            return {
                currency:"",
                totalRides:0,
                showing:"all",
                originalCategories:[],
                originalSeries:[],
                loading:false,
                exporting: {
                    enabled: true
                },
                codeReport : "profit-percent-rides",
                chartOptions:{
                    title: {
                        text: ''
                    },
                    tooltip: {
                        formatter: function(tooltip) {
                            let original = tooltip.defaultFormatter.call(this, tooltip);
                            let detalle   = this.point.details??{};
                            for (let status in detalle ){
                                original.push(status+"= <b>"+detalle[status]+"</b><br/>");
                            }
                            return original;
                        }
                    },
                    yAxis: {
                        title: {
                            text: '%'
                        },
                        plotLines: [
                            
                        ]
                    },
                    exporting:{
                        buttons:{
                            menuItems:["viewFullscreen"]
                        }
                    },
                    chart:{
                        type:'column'
                    },
                    xAxis:{
                        type: 'category',
                        categories:[],
                        max:null,
                    },
                    plotOptions: {
                        series: {
                            cursor: 'pointer',
                            point: {
                                events: {
                                    click: function () {
                                        const selectedDate = this.category;
                                        const selectedDateS = this.series.name;
                                        console.log(selectedDate,selectedDateS);
                                        // 'this' refers to the clicked point
                                        // Call Vue method to handle the selected date
                                        // Use a global function or pass via `this.$emit` or binding
                                        
                                    }
                                }
                            }
                        }
                    },
                    series: seriesExample
                },
                selectedCategory:"",
                by:"vehicle"
            }
        },
        methods:{
            fetchDataChart(){
                this.loading=true;
                let localFilters = {...this.filters,...{by: this.by}}
                api(this).get(`/dashboard/operations/charts/${this.codeReport}`,{params: {filters:localFilters}}).then((res) => {
                    this.currency           = res.data.currency;
                    this.totalRides         = res.data.totalRides;
                    this.originalCategories = res.data.categories;
                    this.originalSeries     = res.data.series;
                    this.chartOptions.series               = res.data.series;
                    this.chartOptions.xAxis.categories     = res.data.categories;
                    this.chartOptions.yAxis.title.text     = "% ("+this.currency.toUpperCase()+")";
                    this.chartOptions.yAxis.plotLines      = res.data.plotLines??[]
                }).catch(this.$root.handleRequestError).finally(()=>{
                    this.$refs.chart.chart.reflow();
                    this.loading=false;
                    this.$emit('finished');
                })
            },
            filterByCategory() {
                if (this.selectedCategory) {
                    const categoryIndex = this.originalCategories.indexOf(this.selectedCategory);
                    // Filter the chart data to show only the selected category
                    this.chartOptions.xAxis.categories = [this.selectedCategory];
                    this.chartOptions.series = this.originalSeries.map(series => ({
                        ...series,
                        data: [series.data[categoryIndex]]
                    }));
                } else {
                    // Reset to show all categories
                    this.resetChart();
                }
                this.$refs.chart.chart.reflow();
            },
            resetChart() {
                // Reset the chart data to the original state
                this.chartOptions.xAxis.categories = this.originalCategories;
                this.chartOptions.series = this.originalSeries;
                this.$refs.chart.chart.reflow();
            }
        },
        watch:{
            showing(){
                if(this.showing >0 ){
                    if((this.showing)<= (this.chartOptions.xAxis.categories.length-1) ){
                        this.chartOptions.xAxis.max= this.showing;
                    }else{
                        this.showing = 'all';
                    }
                }else{
                    this.chartOptions.xAxis.max = null;
                }
            },
            triggerSearch(){//este valor es reactivo, el padre decide en que momento se dispara la busqueda
                this.fetchDataChart();
            }
        },
        mounted() {
            if(this.triggerSearch>0){
                this.fetchDataChart();
            }
        }
    }
</script>

<style scoped>

</style>